var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-skeleton", { attrs: { animation: "fade", height: "3rem" } }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("b-skeleton", {
                staticClass: "mr-3",
                attrs: { animation: "fade", height: "20rem", width: "50%" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _c("b-skeleton", {
                staticClass: "ml-3",
                attrs: { animation: "fade", height: "20rem", width: "50%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-skeleton", {
        staticClass: "mt-5",
        attrs: { animation: "fade", height: "20rem" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }